// R49 Android + iOS companion. The native interface commits on its bridge worker and
// acknowledges that request only after persistence. Legacy SDKs keep R47 behavior.
let sequence = 0;
export function requiresNativeCheckpoint() {
    return typeof navigator !== 'undefined' && /OPLoginCheckpoint\/1(?:\s|$)/.test(navigator.userAgent || '');
}
function capability(gameId) {
    if (typeof window === 'undefined') return null;
    const value = window.__opLoginCheckpoint;
    const bridge = window.OPLoginCheckpoint;
    return value && value.version === 1 && [0, 1, 2].includes(value.environment) && value.gameId === gameId
        && typeof value.nonce === 'string' && value.nonce && bridge
        && typeof bridge.save === 'function' && typeof bridge.clear === 'function' ? {value, bridge} : null;
}
const pause = ms => new Promise(resolve => setTimeout(resolve, ms));
async function ready(gameId) {
    const deadline = Date.now() + 5000;
    do {
        const result = capability(gameId);
        if (result) return result;
        await pause(50);
    } while (Date.now() < deadline);
    return null;
}
async function send(gameId, operation, values, isCurrent = () => true) {
    if (!requiresNativeCheckpoint()) return {required: false, ok: false};
    const initial = await ready(gameId);
    if (!initial || !isCurrent()) return {required: true, ok: false};
    for (let attempt = 0; attempt < 3 && isCurrent(); attempt++) {
        const current = capability(gameId);
        if (!current) return {required: true, ok: false};
        const next = ++sequence;
        const requestId = Date.now() + ':' + next;
        try {
            const response = JSON.parse(await current.bridge[operation](current.value.nonce,
                JSON.stringify({...values, requestId, sequence: next})));
            if (response && response.ok === true && response.requestId === requestId && isCurrent()) return {required: true, ok: true};
        } catch (_) { /* A failed ACK must not be reported as saved. */ }
        if (attempt < 2) await pause(150 * (attempt + 1));
    }
    return {required: true, ok: false};
}
export function saveNativeLogin(session, isCurrent) {
    return send(session.gameId, 'save', {session: {
        gameId: session.gameId, userId: session.userId, accessToken: session.accessToken
    }}, isCurrent);
}
export async function forgetNativeLogin(gameId, expectedToken) {
    const result = await send(gameId, 'clear', {expectedToken: expectedToken || null});
    return !result.required || result.ok;
}
